export enum RoutesPath {
  base = '/',
  login = '/login',
  dashboard = '/dashboard',
  dashboardBilling = '/dashboard/faturamento',
  reception = '/dashboard/recepcao',
  clients = '/dashboard/clientes',
  students = '/dashboard/alunos',
  consultant = '/dashboard/consultant',
  finance = '/dashboard/financeiro',
  reports = '/dashboard/relatorios',
  gyns = '/dashboard/minha-academia',
  plans = '/dashboard/planos',
  employees = '/dashboard/funcionarios',
  sales = '/dashboard/vendas',
  costCenter = 'dashboard/centro-custo',
  units = '/dashboard/units',
  users = '/dashboard/users',
  roomsAndSessions = '/dashboard/calendar',
  contract = '/dashboard/contrato',
  cashRegister = '/dashboard/caixa',
  servicesAndProducts = '/dashboard/servicos-e-produtos',
  excercise = '/dashboard/exercicio',
  sheetExercise = '/dashboard/ficha-exercicio',
  forgotPassword = '/login/esqueci-minha-senha'
}
